import "@/styles/index.css";

import { mount } from "@/lib/mount";
import { ProjectPage } from "@/sections/ProjectPage";
import { projectBySlug } from "@/content/projects";

mount(<ProjectPage project={projectBySlug("job-safety-analysis-review")} />);
